import { useCheckDevice } from '@hooks/UseCheckDevice';
import { useConfig } from '@hooks/UseConfig';
import { isAuth0 } from '@services/auth/AuthService';
import { UsersService } from '@services/users/UsersService';
import { ErrorToast } from '@services/utils/ToastUtils';
import { FC } from 'react';
import { ButtonWrapper } from '../UserProfileStyles';

type UserProfileChangePasswordProps = {
  isPrimaryUser: boolean;
  isIncentiveAdvantageType: boolean;
  showChangePassword: boolean;
  showChangePasswordToggle: () => void;
};

const UserProfileChangePassword: FC<UserProfileChangePasswordProps> = (props) => {
  const { stsAuthority } = useConfig();
  const changePasswordAuth0 = (event) => {
    event.preventDefault();
    UsersService.getChangePasswordTicket()
      .then((ticket) => {
        window.open(ticket.ticket, '_blank').focus();
      })
      .catch((error) => {
        ErrorToast('Error getting change password ticket');
      });
  };

  const { isPrimaryUser, isIncentiveAdvantageType, showChangePassword, showChangePasswordToggle } =
    props;
  const { isMobileDevice } = useCheckDevice();

  if (isAuth0(stsAuthority)) {
    return (
      <>
        <ButtonWrapper
          width='100%'
          height='33px'
          isDisable={false}
          marginBottom='15'
          marginTop='16'
          onClick={changePasswordAuth0}
        >
          CHANGE PASSWORD <i className='am-icon am-icon-ext-link' />
        </ButtonWrapper>
      </>
    );
  }
  return (
    <>
      {!isPrimaryUser && !isIncentiveAdvantageType && !showChangePassword && (
        <ButtonWrapper
          width='100%'
          height='33px'
          isDisable={false}
          marginBottom='15'
          marginTop='16'
          onClick={showChangePasswordToggle}
        >
          CHANGE PASSWORD
        </ButtonWrapper>
      )}
      {!isPrimaryUser && !isIncentiveAdvantageType && showChangePassword && !isMobileDevice && (
        <ButtonWrapper
          width='100%'
          height='33px'
          color='inherit'
          isDisable={true}
          marginBottom='15'
          marginTop='16'
          onClick={showChangePasswordToggle}
        >
          CANCEL PW CHANGE
        </ButtonWrapper>
      )}
    </>
  );
};

export default UserProfileChangePassword;
